// Translations for 12 major world languages
// Key strings only — fallback to English when missing
export const LANGS = [
  { code: "fr", label: "Français", flag: "FR" },
  { code: "en", label: "English", flag: "EN" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "pt", label: "Português", flag: "PT" },
  { code: "ru", label: "Русский", flag: "RU" },
  { code: "zh", label: "中文", flag: "ZH" },
  { code: "ja", label: "日本語", flag: "JA" },
  { code: "ar", label: "العربية", flag: "AR" },
  { code: "hi", label: "हिन्दी", flag: "HI" },
  { code: "ko", label: "한국어", flag: "KO" },
];

const T = {
  en: {
    nav_dashboard: "Dashboard",
    nav_scanner: "AI Scanner",
    nav_programs: "Programs",
    nav_settings: "Settings",
    nav_login: "Login",
    nav_register: "Get Started",
    nav_logout: "Logout",
    hero_title: "AI THAT HUNTS EXPONENTIAL GAINS",
    hero_sub: "100% automated crypto trading powered by Claude AI. Scans DexScreener & PumpFun in real-time and detects tokens with exponential upside potential before the world.",
    hero_cta: "Start Trading",
    hero_cta2: "See Live Opportunities",
    program_basic: "BASIC TRADER",
    program_memecoins: "MEMECOIN HUNTER",
    program_pepite: "PÉPITE",
    min_deposit: "Min. deposit",
    one_time: "one-time access",
    subscribe: "Activate Program",
    feature_ai: "Claude Sonnet 4.5 AI signals",
    feature_auto: "100% Automated execution",
    feature_realtime: "Real-time scanner",
    risk_title: "RISK DISCLOSURE",
    risk_body: "Crypto trading carries extreme financial risk. Past performance does not guarantee future results. You may lose all your capital. You provide your own Binance API keys and Phantom wallet. The platform never custodies your funds.",
    login_title: "Sign in",
    register_title: "Create account",
    email: "Email",
    password: "Password",
    full_name: "Full name",
    submit: "Continue",
    or: "or",
    have_account: "Already have an account?",
    no_account: "No account yet?",
    dashboard_title: "Trading Terminal",
    opportunities: "Live Opportunities",
    ai_signals: "AI Signals",
    portfolio: "Portfolio",
    open_positions: "Open positions",
    closed_positions: "Closed",
    invested: "Invested",
    realized_pnl: "Realized P&L",
    multiplier: "Potential",
    price: "Price",
    market_cap: "Market Cap",
    volume: "Volume 24h",
    liquidity: "Liquidity",
    age: "Age",
    score: "Score",
    generate_signal: "Generate AI Signal",
    open_position: "Open Position",
    close_position: "Close",
    settings_title: "Connect your trading accounts",
    binance_title: "Binance API",
    binance_desc: "Required for trading BTC, ETH, SOL and majors. Read-only or trade permissions only — never withdrawal.",
    coinbase_title: "Coinbase API",
    coinbase_desc: "Connect your Coinbase Advanced Trade API keys to trade BTC, ETH and majors on Coinbase. Trade scope only — never withdrawal.",
    phantom_title: "Phantom Wallet",
    phantom_desc: "Required for memecoins and PumpFun tokens on Solana. Connect by pasting your public wallet address.",
    metamask_title: "MetaMask Wallet",
    metamask_desc: "Required for tokens on EVM chains (Ethereum, BSC, Base, Arbitrum, Polygon...). Connect with one click or paste your public address.",
    security_note: "Exchange API keys are stored securely. Never enable withdrawal permissions on the keys you provide. Only trade or read-only scopes are needed. Wallet connections only use your PUBLIC address.",
    api_key: "API Key",
    api_secret: "API Secret",
    wallet_address: "Wallet address",
    save: "Save",
    connected: "Connected",
    disconnect: "Disconnect",
    payment_processing: "Processing your crypto payment...",
    payment_success: "Payment successful — program activated",
    payment_failed: "Payment failed. Please try again.",
    program_active: "ACTIVE",
    chain: "Chain",
    action_buy: "BUY",
    action_sell: "SELL",
    action_hold: "HOLD",
    confidence: "Confidence",
    risk: "Risk",
    reasoning: "Reasoning",
    refresh: "Refresh",
    loading: "Loading…",
    search: "Search token...",
    nav_autotrade: "Auto-Trade",
    autotrade_title: "Auto-Trading Bot",
    autotrade_sub: "The AI scans ALL blockchains every 5 minutes, buys the best opportunities automatically and sells at take-profit or stop-loss.",
    bot_active: "Bot active",
    bot_inactive: "Bot off",
    bot_settings: "Bot settings",
    amount_per_trade: "Amount / trade ($)",
    max_positions: "Max positions",
    min_confidence: "Min AI confidence",
    ai_dynamic: "AI dynamic TP/SL",
    ai_dynamic_desc: "The AI sets take-profit & stop-loss based on each token's risk level.",
    take_profit: "Take-profit",
    stop_loss: "Stop-loss",
    chains_title: "Blockchains to trade",
    all_chains: "All chains",
    save_settings: "Save settings",
    settings_saved: "Settings saved",
    run_now: "Scan now",
    scan_done: "Scan complete",
    activity_feed: "Bot activity",
    scan_freq: "auto-scan every 5 min",
    no_activity: "No activity yet — enable the bot to start automated trading",
    auto_positions: "Auto positions",
    no_auto_positions: "No automated positions yet",
    bot_on_msg: "Bot activated — trading on all blockchains",
    bot_off_msg: "Bot deactivated",
    push_title: "Push notifications",
    push_desc: "Get alerted on your phone for every bot BUY/SELL.",
    push_enabled_msg: "Push notifications enabled",
    push_disabled_msg: "Push notifications disabled",
    push_denied: "Permission denied by browser",
    push_unsupported: "Push not supported on this browser",
    push_failed: "Failed to enable push",
    push_test: "Send test notification",
    push_test_sent: "Test notification sent",
    recap_now: "Today's recap",
    recap_sent: "Daily recap sent",
    nav_performance: "Performance",
    perf_title: "Bot Performance — Live",
    perf_sub: "Real results of the X1K.AI auto-trading bot across all blockchains. Fully transparent: every closed trade counts, wins AND losses.",
    perf_trades: "Trades executed",
    perf_winrate: "Win rate",
    perf_pnl: "Net cumulative P&L",
    perf_open: "Open positions",
    perf_chains: "Chains scanned",
    perf_chart_title: "Cumulative P&L (30 days)",
    perf_best: "Best trades",
    perf_no_data: "Not enough data yet — the bot is warming up",
    perf_cta_title: "Let the AI trade for you",
    perf_cta_sub: "Activate a program and the bot scans 17 blockchains 24/7, buying and selling automatically. Commission charged on winning trades only.",
    hero_perf_link: "See live performance",
    pay_crypto: "Pay with Card / Crypto",
    pay_paypal: "Pay with PayPal",
    pay_methods_note: "Card & USDC (Stripe Crypto) or PayPal",
    cta_final: "Ready to hunt exponential gains?",
    tier_x1M: "EXTREME",
    tier_x1000: "VERY HIGH",
    tier_x100: "HIGH",
    tier_x10: "MODERATE",
    comp_link: "Risk & Compliance",
    comp_title: "Risk & Compliance",
    comp_intro: "X1K.AI is an automated trading technology platform. Before using our services, please read the following disclosures carefully.",
    comp_s1_title: "Capital at risk",
    comp_s1_body: "Trading cryptocurrencies involves a high level of risk. The value of digital assets is extremely volatile and you may lose all of the capital you allocate to trading. Never invest money you cannot afford to lose. Past performance, including performance displayed on this site, is not indicative of future results.",
    comp_s2_title: "No guaranteed returns",
    comp_s2_body: "X1K.AI does not guarantee any profit, return or performance. AI-generated signals are probabilistic estimates based on market data and may be wrong. 'Exponential potential' labels are analytical classifications, not promises of gains.",
    comp_s3_title: "Transparent fee model",
    comp_s3_body: "Access programs are one-time purchases. On top of that, a performance commission of 10% to 20% (depending on your program) is charged exclusively on winning trades. No commission is ever charged on losing trades.",
    comp_s4_title: "Not financial advice",
    comp_s4_body: "Nothing on this platform constitutes financial, investment, legal or tax advice. X1K.AI is not a licensed financial advisor, broker or asset manager. You remain solely responsible for your trading decisions and for complying with the laws and tax obligations of your jurisdiction.",
    comp_s5_title: "Security & custody",
    comp_s5_body: "X1K.AI never asks for withdrawal permissions on your exchange API keys and only uses your PUBLIC wallet addresses. Your funds remain in your own accounts and wallets at all times. Enable trade-only or read-only scopes on the API keys you connect.",
    comp_contact: "Questions or complaints",
  },
  fr: {
    nav_dashboard: "Tableau de bord",
    nav_scanner: "IA Scanner",
    nav_programs: "Programmes",
    nav_settings: "Paramètres",
    nav_login: "Connexion",
    nav_register: "Commencer",
    nav_logout: "Déconnexion",
    hero_title: "L'IA QUI CHASSE LES GAINS EXPONENTIELS",
    hero_sub: "Trading crypto 100% automatisé propulsé par Claude IA. Scan DexScreener & PumpFun en temps réel : détecte les tokens à potentiel de gains exponentiels avant tout le monde.",
    hero_cta: "Commencer à trader",
    hero_cta2: "Voir les opportunités",
    program_basic: "TRADER BASIQUE",
    program_memecoins: "CHASSEUR DE MEMECOIN",
    program_pepite: "PÉPITE",
    min_deposit: "Dépôt minimum",
    one_time: "accès unique",
    subscribe: "Activer le programme",
    feature_ai: "Signaux IA Claude Sonnet 4.5",
    feature_auto: "Exécution 100% automatique",
    feature_realtime: "Scanner temps réel",
    risk_title: "AVERTISSEMENT RISQUE",
    risk_body: "Le trading crypto comporte un risque financier extrême. Les performances passées ne garantissent pas les résultats futurs. Vous pouvez perdre tout votre capital. Vous fournissez vos propres clés API Binance et wallet Phantom. La plateforme ne détient jamais vos fonds.",
    login_title: "Connexion",
    register_title: "Créer un compte",
    email: "Email",
    password: "Mot de passe",
    full_name: "Nom complet",
    submit: "Continuer",
    or: "ou",
    have_account: "Déjà un compte ?",
    no_account: "Pas encore de compte ?",
    dashboard_title: "Terminal de trading",
    opportunities: "Opportunités en direct",
    ai_signals: "Signaux IA",
    portfolio: "Portefeuille",
    open_positions: "Positions ouvertes",
    closed_positions: "Fermées",
    invested: "Investi",
    realized_pnl: "P&L Réalisé",
    multiplier: "Potentiel",
    price: "Prix",
    market_cap: "Cap. marché",
    volume: "Volume 24h",
    liquidity: "Liquidité",
    age: "Âge",
    score: "Score",
    generate_signal: "Générer signal IA",
    open_position: "Ouvrir position",
    close_position: "Fermer",
    settings_title: "Connectez vos comptes de trading",
    binance_title: "Binance API",
    binance_desc: "Requis pour BTC, ETH, SOL et majors. Permissions lecture ou trading uniquement — jamais de retrait.",
    coinbase_title: "Coinbase API",
    coinbase_desc: "Connectez vos clés API Coinbase Advanced Trade pour trader BTC, ETH et majors sur Coinbase. Permission trading uniquement — jamais de retrait.",
    phantom_title: "Wallet Phantom",
    phantom_desc: "Requis pour les memecoins et tokens PumpFun sur Solana. Collez votre adresse de wallet publique.",
    metamask_title: "Wallet MetaMask",
    metamask_desc: "Requis pour les tokens sur chaînes EVM (Ethereum, BSC, Base, Arbitrum, Polygon...). Connexion en un clic ou collez votre adresse publique.",
    security_note: "Les clés API des exchanges sont stockées de manière sécurisée. N'activez jamais la permission de retrait sur les clés fournies. Seuls les droits trading ou lecture sont nécessaires. Les connexions wallet n'utilisent que votre adresse PUBLIQUE.",
    api_key: "Clé API",
    api_secret: "Secret API",
    wallet_address: "Adresse du wallet",
    save: "Enregistrer",
    connected: "Connecté",
    disconnect: "Déconnecter",
    payment_processing: "Traitement de votre paiement crypto...",
    payment_success: "Paiement réussi — programme activé",
    payment_failed: "Échec du paiement. Veuillez réessayer.",
    program_active: "ACTIF",
    chain: "Chaîne",
    action_buy: "ACHETER",
    action_sell: "VENDRE",
    action_hold: "TENIR",
    confidence: "Confiance",
    risk: "Risque",
    reasoning: "Analyse",
    refresh: "Actualiser",
    loading: "Chargement…",
    search: "Chercher un token...",
    nav_autotrade: "Auto-Trade",
    autotrade_title: "Robot de Trading Automatique",
    autotrade_sub: "L'IA scanne TOUTES les blockchains toutes les 5 minutes, achète automatiquement les meilleures opportunités et revend au take-profit ou stop-loss.",
    bot_active: "Bot actif",
    bot_inactive: "Bot éteint",
    bot_settings: "Réglages du bot",
    amount_per_trade: "Montant / trade ($)",
    max_positions: "Positions max",
    min_confidence: "Confiance IA min",
    ai_dynamic: "TP/SL dynamique par IA",
    ai_dynamic_desc: "L'IA définit le take-profit et le stop-loss selon le niveau de risque de chaque token.",
    take_profit: "Take-profit",
    stop_loss: "Stop-loss",
    chains_title: "Blockchains à trader",
    all_chains: "Toutes les chaînes",
    save_settings: "Enregistrer",
    settings_saved: "Réglages enregistrés",
    run_now: "Scanner maintenant",
    scan_done: "Scan terminé",
    activity_feed: "Activité du bot",
    scan_freq: "scan auto toutes les 5 min",
    no_activity: "Aucune activité — activez le bot pour lancer le trading automatique",
    auto_positions: "Positions automatiques",
    no_auto_positions: "Aucune position automatique pour le moment",
    bot_on_msg: "Bot activé — trading sur toutes les blockchains",
    bot_off_msg: "Bot désactivé",
    push_title: "Notifications push",
    push_desc: "Recevez une alerte sur votre téléphone à chaque achat/vente du bot.",
    push_enabled_msg: "Notifications push activées",
    push_disabled_msg: "Notifications push désactivées",
    push_denied: "Permission refusée par le navigateur",
    push_unsupported: "Push non supporté sur ce navigateur",
    push_failed: "Échec de l'activation des notifications",
    push_test: "Envoyer une notification de test",
    push_test_sent: "Notification de test envoyée",
    recap_now: "Récap du jour",
    recap_sent: "Récap quotidien envoyé",
    nav_performance: "Performance",
    perf_title: "Performance du bot — En direct",
    perf_sub: "Résultats réels du bot de trading automatique X1K.AI sur toutes les blockchains. Transparence totale : chaque trade fermé compte, gains ET pertes.",
    perf_trades: "Trades exécutés",
    perf_winrate: "Taux de réussite",
    perf_pnl: "P&L net cumulé",
    perf_open: "Positions ouvertes",
    perf_chains: "Chaînes scannées",
    perf_chart_title: "P&L cumulé (30 jours)",
    perf_best: "Meilleurs trades",
    perf_no_data: "Pas encore assez de données — le bot chauffe",
    perf_cta_title: "Laissez l'IA trader pour vous",
    perf_cta_sub: "Activez un programme et le bot scanne 17 blockchains 24/7, achète et revend automatiquement. Commission prélevée uniquement sur les trades gagnants.",
    hero_perf_link: "Voir la performance en direct",
    pay_crypto: "Payer en Carte / Crypto",
    pay_paypal: "Payer avec PayPal",
    pay_methods_note: "Carte & USDC (Stripe Crypto) ou PayPal",
    cta_final: "Prêt à chasser les gains exponentiels ?",
    tier_x1M: "EXTRÊME",
    tier_x1000: "TRÈS ÉLEVÉ",
    tier_x100: "ÉLEVÉ",
    tier_x10: "MODÉRÉ",
    comp_link: "Risques & Conformité",
    comp_title: "Risques & Conformité",
    comp_intro: "X1K.AI est une plateforme technologique de trading automatisé. Avant d'utiliser nos services, lisez attentivement les informations suivantes.",
    comp_s1_title: "Capital à risque",
    comp_s1_body: "Le trading de cryptomonnaies comporte un niveau de risque élevé. La valeur des actifs numériques est extrêmement volatile et vous pouvez perdre la totalité du capital alloué au trading. N'investissez jamais d'argent que vous ne pouvez pas vous permettre de perdre. Les performances passées, y compris celles affichées sur ce site, ne préjugent pas des résultats futurs.",
    comp_s2_title: "Aucun rendement garanti",
    comp_s2_body: "X1K.AI ne garantit aucun profit, rendement ou performance. Les signaux générés par l'IA sont des estimations probabilistes basées sur les données de marché et peuvent être erronés. Les libellés de « potentiel exponentiel » sont des classifications analytiques, pas des promesses de gains.",
    comp_s3_title: "Modèle de frais transparent",
    comp_s3_body: "Les programmes d'accès sont des achats uniques. En complément, une commission de performance de 10% à 20% (selon votre programme) est prélevée exclusivement sur les trades gagnants. Aucune commission n'est jamais prélevée sur les trades perdants.",
    comp_s4_title: "Pas un conseil financier",
    comp_s4_body: "Rien sur cette plateforme ne constitue un conseil financier, d'investissement, juridique ou fiscal. X1K.AI n'est ni un conseiller financier agréé, ni un courtier, ni un gestionnaire d'actifs. Vous restez seul responsable de vos décisions de trading et du respect des lois et obligations fiscales de votre juridiction.",
    comp_s5_title: "Sécurité & garde des fonds",
    comp_s5_body: "X1K.AI ne demande jamais de permission de retrait sur vos clés API d'exchange et n'utilise que vos adresses de wallet PUBLIQUES. Vos fonds restent à tout moment sur vos propres comptes et wallets. Activez uniquement les permissions trading ou lecture sur les clés API que vous connectez.",
    comp_contact: "Questions ou réclamations",
  },
  es: {
    hero_title: "LA IA QUE CAZA GANANCIAS EXPONENCIALES",
    hero_sub: "Trading cripto 100% automatizado con Claude AI. Detecta tokens con potencial de ganancias exponenciales antes que nadie.",
    hero_cta: "Empezar a operar",
    nav_login: "Iniciar sesión",
    nav_register: "Empezar",
  },
  de: { hero_title: "KI AUF DER JAGD NACH EXPONENTIELLEN GEWINNEN", hero_cta: "Jetzt traden", nav_login: "Anmelden", nav_register: "Loslegen" },
  it: { hero_title: "L'IA CHE CACCIA GUADAGNI ESPONENZIALI", hero_cta: "Inizia a fare trading", nav_login: "Accedi", nav_register: "Inizia" },
  pt: { hero_title: "A IA QUE CAÇA GANHOS EXPONENCIAIS", hero_cta: "Começar a operar", nav_login: "Entrar", nav_register: "Começar" },
  ru: { hero_title: "ИИ, ОХОТЯЩИЙСЯ ЗА ЭКСПОНЕНЦИАЛЬНОЙ ПРИБЫЛЬЮ", hero_cta: "Начать торговлю", nav_login: "Войти", nav_register: "Начать" },
  zh: { hero_title: "追寻指数级收益的 AI", hero_cta: "开始交易", nav_login: "登录", nav_register: "开始" },
  ja: { hero_title: "指数関数的な利益を狙うAI", hero_cta: "取引を始める", nav_login: "ログイン", nav_register: "始める" },
  ar: { hero_title: "ذكاء اصطناعي يطارد المكاسب الأسية", hero_cta: "ابدأ التداول", nav_login: "تسجيل", nav_register: "ابدأ" },
  hi: { hero_title: "AI जो घातीय मुनाफ़े की तलाश करता है", hero_cta: "ट्रेडिंग शुरू करें", nav_login: "लॉगिन", nav_register: "शुरू करें" },
  ko: { hero_title: "기하급수적 수익을 사냥하는 AI", hero_cta: "거래 시작", nav_login: "로그인", nav_register: "시작" },
};

export function t(key, lang = "en") {
  return (T[lang] && T[lang][key]) || T.en[key] || key;
}

export default T;
